import type { GlobalSearchResultItem } from 'models';
import { useTranslation } from 'react-i18next';

import { Avatar } from 'ui';
import { images } from 'common/utils';
import { SearchItemContent } from '../search-item-content';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const OrganizationItem = ({ itemActionProps, itemProps }: P) => {
  const { t } = useTranslation();

  return (
    <SearchItemRow
      icon={<Avatar alt={itemProps.name} photo={itemProps.profilePhoto ?? images.default.organizationProfilePhoto} />}
      itemActionProps={itemActionProps}
    >
      <SearchItemContent subtitle={itemProps.joined ? t('Joined') : t('Not Joined')} title={itemProps.name ?? ''} />
    </SearchItemRow>
  );
};

export default OrganizationItem;
